var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-tabs',{attrs:{"background-color":"#f8f8f8"},on:{"change":(v) => _vm.registerChange(v)}},_vm._l((_vm.options),function(option){return _c('v-tab',{key:option.value},[_vm._v(_vm._s(option.text))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }